import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { AboutUsComponent } from '../../sharedcomponents/about-us/about-us.component';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { PromotionalcodeserviceService } from '../../_services/sharedpromotionalcode/promotionalcodeservice.service';
import { utilityService } from '../commonservice/utility.service';
import { enumStatusCodeList } from '../_common/constants/app.constants';
import { EmailListComponent } from './email/email-list/email-list.component';
declare var ___MobileAgent___: any;
@Component({
  selector: 'app-sharepromotionalcode',
  templateUrl: './sharepromotionalcode.component.html',
  styleUrls: ['./sharepromotionalcode.component.css'],
  providers: [PromotionalcodeserviceService, utilityService, AlertService]
})
export class SharepromotionalcodeComponent implements OnInit {
  sharedImage: any;
  isCopied2 = false;
  description;
  textToCopy;
  referralCode;
  public repoUrl: string;
  public repoUrlforFB: string;
  constructor(
    private sharePromotionCode: PromotionalcodeserviceService,
    public utilserv: utilityService,
    public translate: TranslateService,
    public modal: Modal,
    private vcRef: ViewContainerRef,
    public geoloc: geolocation,
    private alertService: AlertService
  ) { }
  ngOnInit() {
    this.utilserv.busy = this.geoloc.getGioLocation().subscribe(data => {
      let userGioLocation = data;
      console.log('Observer got a next value: ' + data);
      this.getPromotionResponse(userGioLocation);
    });
  }
  copyToClipboard() {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.repoUrl;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    // this.modal.overlay.defaultViewContainer = this.vcRef;
    // this.textToCopy = this.repoUrl;
    // alert('Copied to Clipboard');
    this.alertService.openErrorAlert(this.translate.instant('Common_lblInfo'), this.translate.instant('SharePopup_lblLinkCopied'));
  }
  sendMail() {
    const modalData: any = {};
    modalData.Title = this.translate.instant('Common_lblInfo').toString();
    modalData.referralCode = this.referralCode;
    modalData.sharedURL = this.repoUrl;
    // modalData.Message = data.Envelope.Body.GetCartItemResponse.StatusMessage;
    modalData.Action = this.translate.instant('CartEmptyPopup_btnGoToDashboard');
    this.modal.overlay.defaultViewContainer = this.vcRef;
    return this.modal.open(EmailListComponent, overlayConfigFactory({ modalData }, BSModalContext));

    // const mailBody =  this.description + '  '
    //                    + this.translate.instant('SharePopup_lblShareContentPost') + '.'
    //                    + this.referralCode + this.repoUrl;
    // const link = 'mailto:' + ''  + '&subject= ' + this.translate.instant('SharePopup_lblShareAndEarn') + '&body=' + mailBody;
    // window.location.href = link;
  }
  getPromotionResponse(userGioLocation: any) {
    this.utilserv.busy = this.sharePromotionCode.getPromotionalCodeService(userGioLocation).subscribe(data => {
      if (data.Envelope.Body.UserReferralResponse.StatusCode == enumStatusCodeList.SUCCESS) {
        this.referralCode = this.utilserv.getObjectText(data.Envelope.Body.UserReferralResponse.ReferralCode);
        this.sharedImage = 'data:image/gif;base64,' + data.Envelope.Body.UserReferralResponse.ShareImage;
        this.repoUrl = this.utilserv.getObjectText(data.Envelope.Body.UserReferralResponse.ReferralLink);
        this.description = this.translate.instant('SharePopup_lblShareContentPre') + '. \n' + this.translate.instant('SharePopup_lblShareContentPost') + ' ' + this.referralCode;
        this.repoUrlforFB = this.repoUrl + '&quote=' + this.description;
      }
    });
  }
  opentermsofuse(objtext) {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    const modalData: any = {};
    modalData.Title = this.translate.instant('SharePopup_linkRestrictionApply');
    modalData.URL = objtext;

    modalData.Action = this.translate.instant('Common_lblOk');
    return this.modal.open(AboutUsComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }

  openFB() {
    ___MobileAgent___.OpenFacebook('https://www.facebook.com/sharer/sharer.php?u=' + this.repoUrlforFB);
  }
  openWhatsApp() {
    //https://faq.whatsapp.com/en/general/26000030/?category=5245251 //article
    ___MobileAgent___.OpenWhatsApp('https://wa.me/?text=' + this.description + ' | ' + this.repoUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/sharepromotionalcode/sharepromotionalcode.component.ts